import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import ProgressBar from 'widget/player-widget/components/progress-bar/progress-bar';
import { pickContextTypes } from '../../context-types';

import styles from './progress.styl';


@WixConnect(styles)
export default class Progress extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
  };

  static contextTypes = pickContextTypes('seek', 'percentageBuffered', 'percentagePlayed', 'duration');

  state = {
    focused: false,
  };

  @autobind
  seek({ target }) {
    const { seek, duration } = this.context;
    seek(target.value * duration / 100);
  }

  @autobind
  onFocus() {
    this.setState({ focused: true });
  }

  @autobind
  onBlur() {
    this.setState({ focused: false });
  }

  render() {
    const { className } = this.props;
    const { focused } = this.state;
    const { percentageBuffered, percentagePlayed } = this.context;

    const styleNames = classnames('seek', {
      focused,
    });

    return (
      <div styleName={styleNames}
           className={className}>
        <div styleName="container">
          <div styleName="buffer-bar"
               style={{ width: `${percentageBuffered}%` }} />
          <ProgressBar onBlur={this.onBlur}
                       onFocus={this.onFocus}
                       onChange={this.seek}
                       progress={percentagePlayed}
                       inputClassName={styles['progress-input']}
                       fillClassName={styles['progress-bar']} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/controls/progress/progress.js